// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3qJTw","footer":"ModalFilter_footer__2JWgY"};